import { useState } from "react";
import axiosInstance from "@/hooks/axios";
import { isAxiosError } from "axios";
import { User } from "@/types/user";

export interface ResendConfirmationEmailData {
  email: User["email"];
}

export interface ResendConfirmationEmailResponse {
  success: boolean;
  message: string;
}

export const useResendConfirmationEmail = () => {
  const [data, setData] = useState<ResendConfirmationEmailResponse | null>(
    null,
  );
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  const resendConfirmationEmail = async (
    formData: ResendConfirmationEmailData,
  ) => {
    setLoading(true);
    setError(null);
    try {
      const response =
        await axiosInstance.post<ResendConfirmationEmailResponse>(
          "users/users/resend_confirmation_email/",
          formData,
        );
      setData(response.data);
    } catch (err: unknown) {
      if (isAxiosError(err)) {
        setError(err.message);
      } else if (err instanceof Error) {
        setError(err.message);
      } else {
        setError("An unknown error occurred.");
      }
    } finally {
      setLoading(false);
    }
  };

  return { data, loading, error, resendConfirmationEmail };
};
